import { render, staticRenderFns } from "./TermOfUseLaerm.vue?vue&type=template&id=32305893&"
import script from "./TermOfUseLaerm.vue?vue&type=script&lang=js&"
export * from "./TermOfUseLaerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports